import { signOut } from 'firebase/auth';

import { initAuth } from './authentication';
import { isSessionRevokingPath } from './is-session-revoking-path';

export const channelName = 'logout_channel';

export enum ChannelEvents {
  Logout = 'logout',
  Login = 'login',
}

let channel: BroadcastChannel | undefined;

export const initChannel = () => {
  if (!channel) {
    channel = new BroadcastChannel(channelName);
    channel.onmessage = async (event) => {
      if (event.data === ChannelEvents.Logout) {
        const auth = await initAuth();
        await signOut(auth);
        if (isSessionRevokingPath(window.location.pathname)) {
          return;
        }
        window.location.reload();
      }

      if (event.data === ChannelEvents.Login) {
        window.location.reload();
      }
    };
  }
};

export const channelLogin = () => {
  if (!channel) {
    initChannel();
  }

  channel!.postMessage(ChannelEvents.Login);
};

export const channelLogout = () => {
  if (!channel) {
    initChannel();
  }

  channel!.postMessage(ChannelEvents.Logout);
};

export const clearChannel = () => {
  channel?.close();
  channel = undefined;
};
